// extracted by mini-css-extract-plugin
module.exports = {"switch":"da51a739f7--switch--JOY1S","icon":"da51a739f7--icon--HmxrC","active":"da51a739f7--active--NPZf_"};